var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconionicVerartes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.679,
    height: 20.684,
    viewBox: "0 0 20.679 20.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-photos",
    "data-name": "Icon ionic-md-photos",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_774",
    "data-name": "Trazado 774",
    d: "M20.872,23.25V10A2.128,2.128,0,0,0,18.75,7.875H5.5A2.128,2.128,0,0,0,3.375,10V23.255A2.128,2.128,0,0,0,5.5,25.377H18.755A2.134,2.134,0,0,0,20.872,23.25ZM8.808,17.419,11.06,20.6l3.316-4.772,4.374,6.363H5.5Z",
    transform: "translate(0 -1.319)",
    fill: "#b2a169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_775",
    "data-name": "Trazado 775",
    d: "M23.25,3.375H10A2.128,2.128,0,0,0,7.875,5.5v.263H20.864a2.128,2.128,0,0,1,2.123,2.123V20.872h.263a2.128,2.128,0,0,0,2.123-2.123V5.5A2.128,2.128,0,0,0,23.25,3.375Z",
    transform: "translate(-1.319 0)",
    fill: "#b2a169"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconionicVerartes);
export default __webpack_public_path__ + "static/media/Icon ionic-ver artes.cc21758749380210061da945824504ba.svg";
export { ForwardRef as ReactComponent };